/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MatchSearchFilterPayload { 
    text_search?: string | null;
    competition_ids?: Array<number> | null;
    category_ids?: Array<number> | null;
    genders?: Array<number> | null;
    team_id?: string | null;
    player_id?: string | null;
    season_id?: number | null;
    date_from?: string | null;
    date_to?: string | null;
    page?: number;
    page_size?: number;
}

